import { defineMessages } from 'react-intl-next';

export default defineMessages({
	noKnowledgeAdded: {
		id: 'rovo-chat.view-agent.no-knowledge-added',
		defaultMessage: 'No custom knowledge sources',
		description: 'Message displayed when no knowledge is added to the agent',
	},
	privateKnowledgeTitle: {
		id: 'rovo-chat.view-agent.hidden-knowledge-title',
		defaultMessage: 'These knowledge is private',
		description:
			'Title of the knowledge section, this is displayed when knowledge is purposely hidden',
	},
	privateKnowledgeDescription: {
		id: 'rovo-chat.view-agent.hidden-knowledge-description',
		defaultMessage:
			'Agents built by Atlassian Marketplace partners have their knowledge hidden for privacy.',
		description:
			'Description of the knowledge section, this is displayed when knowledge is purposely hidden',
	},
} as const);
